import { formatPrice } from '../../../../utils/common'
import styles from '../Billing.module.scss'

const TotalRow = ({
  pageBalanceRemaining,
  pageItemCount,
  totalBalanceRemaining,
  totalCount,
  showPageTotals
}) => (
  <div
    className={`${styles.billingSummary} ${
      showPageTotals ? '' : styles.billingSummaryCompact
    }`}
  >
    <div className={styles.billingSummaryItem}>
      <span className={styles.billingSummaryLabel}>All invoices</span>
      <strong className={styles.billingSummaryValue}>{totalCount}</strong>
    </div>
    <div className={styles.billingSummaryItem}>
      <span className={styles.billingSummaryLabel}>Total open balance</span>
      <strong className={styles.billingSummaryValue}>
        {formatPrice(totalBalanceRemaining)}
      </strong>
    </div>
    {showPageTotals && (
      <div className={styles.billingSummaryItem}>
        <span className={styles.billingSummaryLabel}>Invoices on this page</span>
        <strong className={styles.billingSummaryValue}>{pageItemCount}</strong>
      </div>
    )}
    {showPageTotals && (
      <div className={styles.billingSummaryItem}>
        <span className={styles.billingSummaryLabel}>Balance on this page</span>
        <strong className={styles.billingSummaryValue}>
          {formatPrice(pageBalanceRemaining)}
        </strong>
      </div>
    )}
  </div>
)

export default TotalRow
